import { Component, OnInit, DoCheck } from '@angular/core';
import { Router } from '@angular/router';



declare var $:any;

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit,DoCheck {
 

  public variable=false;
 

  constructor(private router:Router) { 
    //this.session=localStorage.getItem("session");
  }
  ngOnInit() {
    
  }

  
  changeClass(){
    
      $('#sidebar').toggleClass('active');
  
  }
  ngDoCheck(): void {
    this.login();
  
  }
  login(){
    
   
    if(localStorage.getItem("session")){
      
      this.variable=true;
    
    }else{     
    
      this.variable=false;
      

    }
    
    
  }
  logout(){
    localStorage.removeItem("session");
    $('#sidebar').removeClass('active');
    this.router.navigate(['/']);
    
  }
}
